import React,{useEffect,useState} from 'react';
import { StyleSheet,View, Text ,FlatList,Pressable,TouchableOpacity,Alert, Image,TextInput} from 'react-native';
import { useNavigation } from '@react-navigation/native';
import Fondo from '../modules/component/Fondo';
import { MaterialCommunityIcons } from '@expo/vector-icons';
import { apiFetch } from '../modules/api';


  const Lotes = () => {

  const [search, setSearch] = useState('');
  const [filteredDataSource, setFilteredDataSource] = useState([]);
  const [masterDataSource, setMasterDataSource] = useState([]);

  const [checked, onChange] = useState(false);  

  const navigation = useNavigation();

  const [errorMsg, setErrorMsg] = useState(null);

  const showAlert = () =>
   
    Alert.alert('La información se guardo de manera exitosa', 'Oprima Aceptar para continuar', [
      { text: "Aceptar",
        onPress: () => navigation.goBack()
     }
      ],
      { cancelable: true });

     

  function onCheckmarkPress(folioFactura,folioRecibo,estatusFactura,monto,fechaEmision){

    global.gFolioFactura = folioFactura;
    global.gFolioRecibo = folioRecibo;
    global.gEstatusFactura = estatusFactura;
    global.gMonto = monto;
    global.gFechaEmision = fechaEmision;
    navigation.navigate("Factura");

  }

  const [facturas,setFacturas] = useState(null);
  
  useEffect(function(){

    let mounted = true;
    async function fetchData(){

      if (mounted) {
       

        const requestOptions = {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' }
          
        }
          global.gEstatusFactura = "EMITIDA";
          const response = await apiFetch(gApiPath + "/api/fact/buscarEstatus/"+gEstatusFactura,requestOptions);
          const json = await response.json();
          setFacturas(json.datos); 
          setFilteredDataSource(json.datos);
          setMasterDataSource(json.datos);
          gCheckbox = {};

      }
  }
  
 
  fetchData();
  return () => mounted = false;

  },[]);

  const searchFilterFunction = (text) => {
    // Check if searched text is not blank
    if (text) {
      // Inserted text is not blank
      // Filter the masterDataSource and update FilteredDataSource
      const newData = masterDataSource.filter(function (item) {
        // Applying filter for the inserted text in search bar
        let textoBuscar = item.folio_factura;
        const itemData = textoBuscar
          ? textoBuscar.toUpperCase()
          : ''.toUpperCase();
        const textData = text.toUpperCase();
        return itemData.indexOf(textData) > -1;
      });
      setFilteredDataSource(newData);
      setSearch(text);
    } else {
      // Inserted text is blank
      // Update FilteredDataSource with masterDataSource
      setFilteredDataSource(masterDataSource);
      setSearch(text);
    }
  };

  const ItemView = ({ item }) => {
    return (
      // Flat List Item
      <Text style={styles.itemStyle} onPress={() => getItem(item)}>
        {item.id}
        {'.'}
        {item.title.toUpperCase()}
      </Text>
    );
  };
    
  const ItemSeparatorView = () => {
    return (
      // Flat List Item Separator
      <View
        style={{
          height: 0.5,
          width: '100%',
          backgroundColor: '#C8C8C8',
        }}
      />
    );
  };

  const getItem = (item) => {
    // Function for click on an item
    alert('Id : ' + item.id + ' Title : ' + item.title);
  };

  function formatoLote(lote,separador,fecha){

    let respuesta = "";

    if (lote.toLowerCase() != "sin lote" && lote.toLowerCase() != "lote no encontrado"){

        respuesta = lote + separador + fecha;

    }else{

      respuesta = lote;

    }

    return respuesta




  }

  
    return (
        <View style={{flex:1,width: '100%', alignItems:'center'}}>
          <Fondo/> 
          <View style={{alignItems: 'center', flexDirection: 'row', flex: 1,marginBottom:10,marginTop:30}}>  
            
          <MaterialCommunityIcons name="text-box-search-outline" size={40} color="#aaa" />
            <TextInput
            style={styles.textInputStyle}
            onChangeText={(text) => searchFilterFunction(text)}
            value={search}
            underlineColorAndroid="transparent"
            placeholder="Buscar folios" 
            />
           
          </View>
          <View style={{alignItems: 'center', flexDirection: 'column', flex: 10}}>  
          <Text style={styles.titulo2}>Folios</Text>
            <FlatList 
              data={filteredDataSource}
              keyExtractor={(item, index) => index.toString()}
              ItemSeparatorComponent={ItemSeparatorView}
              renderItem={({item}) => <View style={{flex:1,aignItems:'center',width: '100%'}}> 

                  <View style={styles.checkboxContainer}>
                  <TouchableOpacity
                    style={styles.checkboxBase}
                    onPress={() => onCheckmarkPress(item.folio_factura,item.folio_recibo,item.estatus,item.monto,item.fecha_emision)}>
                    <Text style={styles.titulo3}>  {item.folio_factura}</Text>
                  </TouchableOpacity> 
                     
                  </View>
                </View> }
               
            />  

      
            </View>
        </View>
    );
    }



export default Lotes

const styles = StyleSheet.create({
 
  titulo:{
    fontSize: 35,
    color: "white",
    fontWeight: 'bold',
    marginTop: 5,
  },text: {
    fontSize: 15,
    color: 'white',
    fontWeight: 'bold',
    textTransform: 'uppercase'
},

  titulo2:{
    fontSize: 30,
    color: "black",
    fontWeight: 'bold',
    paddingBottom: 10
  },
  
  titulo3:{
    fontSize: 30,
    color: "white",
    fontWeight: 'bold',
    paddingBottom: 10
  },
button:{

  padding: 5,
  width: '100%',
  height: '95%',
  borderRadius:10 ,
  fontWeight: 'bold',
  alignItems: 'center',
  justifyContent : 'center',
  marginTop: 5,
  marginBottom : 5

},
container2:{
    flex:1,
    marginTop: 10,
    alignItems: 'center',
    justifyContent : 'center',
    width: '100%',
   
}, checkboxBase: {
    width: "100%",
    height: "100%",
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: 10,
    borderWidth: 4,
    borderColor: 'white',
    backgroundColor: '#4c669f',
  },container5:{
        
    alignItems: 'center',
    justifyContent : 'center',
    marginTop:20,
    width: '80%'} ,

  checkboxChecked: {
    backgroundColor: 'coral',
  },

  checkboxContainer: {
    flex:1,
    flexDirection: 'row',
    alignItems: 'center',
    marginTop : 10,
    width: '90%'
    
  },
  itemStyle: {
    padding: 10,
  },
  textInputStyle: {
    width: '70%',
    height: 50,
    borderWidth: 1,
    paddingLeft: 20,
    margin: 5,
    borderColor: '#009688',
    backgroundColor: '#FFFFFF',
    borderRadius: 10,
    fontSize: 20,
    fontWeight: 'bold',
    
  },
     
       
});


